var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { alias, disgardOldValue, object } from '../../utils/serializr/serializr';
import { Question } from '../../classes/question/Question';
import { QuestionTypeName } from '../../classes/learnware/LearnwareEnums';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { primitive } from '../../utils/serializr/schema/inner/primitive';
import { withInit } from '../../utils/serializr/schema/middle/withInit';
import { ThinkAndRevealStore } from './modules/ThinkAndRevealStore';
import { ThinkAndRevealScore } from './modules/ThinkAndRevealScore';
import { editable } from '../../utils/mobx/decorators/editable';
export class QuestionThinkAndReveal extends Question {
    questionType = QuestionTypeName.ThinkAndReveal;
    isRevealed = false;
    wasKnown = false;
    isComplete = false;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get exportingChildren() {
        return [...super.exportingChildren];
    }
    // @observable needed because accessed before deserialize (by @computed)
    thinkAndRevealStore;
    get questionTypeStore() {
        return this.thinkAndRevealStore;
    }
    get questionScore() {
        return new ThinkAndRevealScore(this);
    }
    static get serializeInfo() {
        return {
            extends: Question.serializeInfo,
            props: {
                questionType: withInit(primitive, QuestionTypeName.ThinkAndReveal),
                thinkAndRevealStore: alias('questionTypeStore', withInit(object(ThinkAndRevealStore), {})),
                textBasis: alias('text', disgardOldValue(primitive)),
            },
        };
    }
}
__decorate([
    editable()
], QuestionThinkAndReveal.prototype, "questionType", void 0);
__decorate([
    observable
], QuestionThinkAndReveal.prototype, "isRevealed", void 0);
__decorate([
    observable
], QuestionThinkAndReveal.prototype, "wasKnown", void 0);
__decorate([
    observable
], QuestionThinkAndReveal.prototype, "isComplete", void 0);
__decorate([
    memoize
], QuestionThinkAndReveal.prototype, "questionScore", null);
__decorate([
    memoize
], QuestionThinkAndReveal, "serializeInfo", null);
